import { useForm } from 'react-hook-form'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import {
  DynamicFormRenderer,
  type DynamicFormValues,
} from '@/features/applications/components/DynamicFormRenderer'
import type { ApplicationSection } from '@/types'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  sections: ApplicationSection[]
}

export function FormPreviewDialog({ open, onOpenChange, sections }: Props) {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm<DynamicFormValues>({
    defaultValues: {
      applicantInfo: { firstName: '', lastName: '', email: '' },
      answers: {},
      files: {},
    },
  })

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Form Preview</DialogTitle>
          <p className="text-sm text-muted-foreground">
            This is how applicants will see the form. Inputs are interactive but submissions are not
            saved.
          </p>
        </DialogHeader>

        {sections.length === 0 ? (
          <p className="py-12 text-center text-sm text-muted-foreground">
            No sections to preview yet.
          </p>
        ) : (
          <div className="mt-2">
            <DynamicFormRenderer
              sections={sections}
              register={register}
              control={control}
              setValue={setValue}
              errors={errors}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
